import { Col, Container, Row } from "reactstrap";
import Description from "./Description";
import { FaRocket } from "react-icons/fa";
import { FaUniversity } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { PiTrafficSignFill } from "react-icons/pi";

const Why = () => {

  const listWhy = [
    { icon:<FaRocket className="why-icon" />, title: "Skill Practical yang Siap Kerja", body: "Program NLC fokus pada applied learning — latihan langsung di lab & workshop, biar kamu gak cuma paham teori tapi siap kerja dari hari pertama."},
    { icon:<FaUniversity className="why-icon" />, title: "Biaya Lebih “Rasional” dibanding Universitas Besar", body: "Biaya kuliah di NLC termasuk lebih rendah dibanding banyak kampus di kota besar Kanada, plus biaya hidup di kota sekitar kampus juga tetap bersahabat."},
    { icon:<FaUserGroup className="why-icon" />, title: "Kelas Kecil + Support untuk Internasional", body: "NLC punya kelas kecil dan staff yang siap bantu dari mulai apply sampai settle di Kanada — jadi kalian benar-benar merasakan experience yang lebih personal."},
    { icon:<PiTrafficSignFill className="why-icon" />, title: "Bisa Dapat Work Permit Setelah Lulus", body: "Beberapa program memenuhi syarat untuk Post-Graduation Work Permit (PGWP), jadi setelah kuliah kamu bisa kerja profesional di Kanada!."},
  ]

  return (
    <section className="section" id="why">
      <Container>
        <Row className="why-wrapper flex-lg-row gap-4">
        <Description />
          <Col>
            <img 
              src="assets/images/img-why.webp" 
              alt="melbourne-polytechnic-sign-and-students-of-melbourne-polytechnic's" 
              className="img-fluid"
            />          
          </Col>
          <Col>
            <h1 className="mb-3"><b>4 Keunggulan Kampus NLC</b></h1>
            <div className="mb-3 mb-md-5">
              {listWhy.map((item, id) => (
                <div key={id} className="d-flex text-start gap-2">
                  <div>
                    {item.icon}         
                  </div>
                  <div>
                      <span className="fw-bold">{item.title}</span>
                      <p className="fw-normal">{item.body}</p>
                  </div>                
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>      
    </section>
  );
};

export default Why;